import { styled } from "@vitality-ds/system";
import IconWrapperStyles from "./styles/IconWrapper.styles";

// eslint-disable-next-line import/prefer-default-export
export var IconWrapper = styled("div", IconWrapperStyles);